<ngx-spinner [name]="'relatorio-boletos'" type="ball-clip-rotate-pulse" [fullScreen]="false"
  bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
  <mat-card-header>
    <mat-card-title>Relatório de Boletos</mat-card-title>
  </mat-card-header>
  <mat-divider></mat-divider>

  <mat-card-content>

    <div class="row mt-2">
      <div class="col-auto" *ngIf="sTipoBusca !== 'Boletos vencidos'">
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Período</mat-label>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [min]="minDate" disabled>
            <input matStartDate formControlName="start" placeholder="Início">
            <input matEndDate formControlName="end" placeholder="Fim">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>

          <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Data inicial inválida
          </mat-error>
          <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Data final inválida</mat-error>
        </mat-form-field>
      </div>

      <div class="col-auto">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>Tipo de busca</mat-label>
          <mat-select [(ngModel)]="sTipoBusca">
            <mat-option *ngFor="let tipo of aTipoBusca" [value]="tipo.value">
              {{tipo.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-auto" *ngIf="sTipoBusca !== 'Boletos vencidos'">
        <mat-form-field appearance="fill" [floatLabel]="'always'">
          <mat-label>Status do boleto</mat-label>
          <mat-select [(ngModel)]="sBuscaStatusBoleto">
            <mat-option *ngFor="let status of aStatusBoleto" [value]="status.value">
              {{status.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>


      <div class="col-auto">
        <button class="mt-4" mat-flat-button color="primary"
          (click)="sTipoBusca !== 'Boletos vencidos' ? buscarBoletos() : filtrarBoletosVencidos()">
          <mat-icon>search</mat-icon> Buscar
        </button>
      </div>


      <div class="col-sm text-right" *ngIf="tipoCadastro === 'Admin'">
        <button class="mt-4" mat-stroked-button color="primary" (click)="sincronizarBoletos()">
          <mat-icon>sync</mat-icon> Sincronizar Sicoob
        </button>
      </div>
    </div>

    <div *ngIf="bConsulta">
      <div class="row">
        <div class="col-sm">
          <mat-divider></mat-divider>
        </div>
      </div>

      <div class="row">
        <div class="col-sm text-right">
          <button mat-flat-button color="warn" class="mt-2" (click)="exportar()">
            <mat-icon>print</mat-icon> Exportar
          </button>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm">
          <table mat-table [dataSource]="boletosSource" class="mat-elevation-z2">

            <ng-container matColumnDef="Pedido">
              <th mat-header-cell *matHeaderCellDef> Pedido </th>
              <td mat-cell *matCellDef="let element"> {{element.Pedido}} </td>
            </ng-container>

            <ng-container matColumnDef="Cliente">
              <th mat-header-cell *matHeaderCellDef> Cliente </th>
              <td mat-cell *matCellDef="let element"> {{element.Cliente}} </td>
            </ng-container>

            <ng-container matColumnDef="TelefoneCliente">
              <th mat-header-cell *matHeaderCellDef> Telefone </th>
              <td mat-cell *matCellDef="let element"> {{element.TelefoneCliente}} </td>
            </ng-container>

            <ng-container matColumnDef="DataEmissao">
              <th mat-header-cell *matHeaderCellDef> Emissão </th>
              <td mat-cell *matCellDef="let element"> {{element.DataEmissao}} </td>
            </ng-container>

            <ng-container matColumnDef="DataVencimento">
              <th mat-header-cell *matHeaderCellDef> Vencimento </th>
              <td mat-cell *matCellDef="let element"> {{element.DataVencimento}} </td>
            </ng-container>

            <ng-container matColumnDef="Valor">
              <th mat-header-cell *matHeaderCellDef> Valor </th>
              <td mat-cell *matCellDef="let element"> {{element.ValorString}} </td>
            </ng-container>

            <ng-container matColumnDef="SituacaoBoleto">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let element"> {{element.Status}} </td>
            </ng-container>

            <ng-container matColumnDef="Download">
              <th mat-header-cell *matHeaderCellDef> Download</th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button matTooltip="Download boleto" (click)="downloadBoleto(element)"
                  class="iconbutton" color="primary">
                  <mat-icon aria-label="Baixar boleto">download</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="Consultar">
              <th mat-header-cell *matHeaderCellDef> Visualizar no pedido</th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button matTooltip="Detalhar no pedido" (click)="visualizarPedido(element)"
                  class="iconbutton" color="primary">
                  <mat-icon aria-label="Consultar pedido">remove_red_eye</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="9" style="text-align: center;">Não há boletos no
                sistema ou com o filtro definido
              </td>
            </tr>
          </table>

          <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]"></mat-paginator>
        </div>
      </div>

    </div>
  </mat-card-content>
</mat-card>
